// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

(function(M, _, $, Backbone) {
  "use strict";

  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};

  /**
   * @class M.Community.View.ChallengeTile
   *
   * TODO: This needs a comment explaining what it does
   */
  M.Community.View.ChallengeTile = Backbone.View.extend({
    className: 'challengeTile',
    template: M.Template.Community.ChallengeTile,

    HOVER_FADING_SPEED_MILLIS: 280,

    render: function() {
      this.$el = $(this.el);
      this.$el.html(this.template(this.model.toJSON()));

      var container = this.$el.find('.challengeBlock');
      var challengeImgUrl = this.model.get('image_url');
      M.assert(challengeImgUrl.indexOf(')') == -1, 'Invalid challenge url');
      container.css('background-image', 'url(' + M.html.htmlAttributeEscape(challengeImgUrl) + ')');
      this._renderChallengeStatus();
      this._renderChallengeTitle();
      this._renderChallengeDate();

      var container = this.$el.find('.challengeBlock');
      var button = this.$el.find('.challengeButton');
      var category = this.$el.find('.challengeCategory');


      if (!M.IS_MOBILE_OPTIMIZED) {
        M.Community.View.Util.Common.addHoverToggleAnimation(
          container, category, button, this.HOVER_FADING_SPEED_MILLIS
        );
      }
      return this;
    },

    _renderChallengeStatus: function() {
      var statusFlags = this.$el.find('.challengeStatusFlag');
      var statusText = this.$el.find('.challengeStatusText');
      var classToFilter = '';
      _.each(
        M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[this.model.get('state')]['tileCssClass'],
        function(tileCssClass){
          classToFilter += " " + tileCssClass;
        });
      this.$el.addClass(classToFilter);
      statusFlags.addClass(
        M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
          this.model.get('state')]['flagCssClass']);
      statusText.text(
        M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
          this.model.get('state')]['flagText']);
      return this;
    },

    _renderChallengeTitle: function() {
      var shortenedTitle = this.model.get('title').truncate(40);
      var titleDiv = this.$el.find('.challengeTitle');
      titleDiv.text(shortenedTitle);
      return this;
    },

    _renderChallengeDate: function() {
      var challengeDateTitle =  this.model.getDeadlineLabelText();
      var challengeDateStr =  this.model.getBannerDateStr('MMMM D');
      var dateDiv = this.$el.find('.challengeSubtitle');
      dateDiv.text(challengeDateTitle + ' ' + challengeDateStr);
      return this;
    }
  });
})(M, _, $, Backbone);
